module.exports = __webpack_public_path__ + "static/media/abhidey.443a9f2b.jpg";